export default "__VITE_ASSET__DfibmYYa__"